/* eslint-disable react-hooks/rules-of-hooks */
import axios from "axios";
import apiClient from "./apiClient";
const username='apiuser';
const password='Intellect@1234'; 
  const fetchAPIV1 = async (endpoint: string) => {
   //   console.log(endpoint);
    try {
      //  console.log(endpoint);
      const res = await axios.get(`/api/${endpoint}?_format=json`, {
        headers: {
          Authorization: 'Basic ' + btoa(username + ':' + password),
        //  'Content-Type': 'application/json',
        //   'Access-Control-Allow-Origin': '*',
        //   'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS' 
        },
      });
    //  console.log(res);
      return res.data;
    } catch (err: any) {
      console.error('Error fetching', endpoint, err);
      throw err;
    } 
  };

 export const fetchAPI = async (endpoint: string) => {
  try {
      const res = await apiClient.get(`${endpoint}?_format=json`, {
        headers: {
          Authorization: 'Basic ' + btoa(username + ':' + password), 
        },
      });
    return res.data;
  } catch (err) {
    console.error("Error fetching", endpoint, err);
    
    throw err;
  }
};
  

export default fetchAPI;
 